import { render, staticRenderFns } from "./articleShare.vue?vue&type=template&id=1197ac37&scoped=true"
import script from "./articleShare.vue?vue&type=script&lang=ts"
export * from "./articleShare.vue?vue&type=script&lang=ts"
import style0 from "./articleShare.vue?vue&type=style&index=0&id=1197ac37&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1197ac37",
  null
  
)

export default component.exports